<template>
  <div class="ud-card" :style="{ width: (750 - marginLeft - marginRight) + 'rpx', marginLeft: marginLeft + 'rpx', marginRight: marginRight + 'rpx', borderRadius: borderRadius+ 'rpx', backgroundColor: color }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'rgba(255, 255, 255, 1)'
    },
    marginLeft: {
      type: Number,
      default: 24
    },
    marginRight: {
      type: Number,
      default: 24
    },
    borderRadius: {
      type: Number,
      default: 6
    }
  }
}
</script>

<style lang="scss" scoped>
.ud-card {
  position: relative;
  overflow: hidden;
  z-index: 1;
  box-sizing: border-box;
}
</style>